import * as Dialog from "@radix-ui/react-dialog";
import styled, { keyframes } from "styled-components";

const overlayShow = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const overlayHide = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const contentShow = keyframes`
  from { opacity: 0; transform: translate(-50%, -48%) scale(.96); }
  to { opacity: 1; transform: translate(-50%, -50%) scale(1); }
`;

const contentHide = keyframes`
  from { opacity: 1; transform: translate(-50%, -50%) scale(1); }
  to { opacity: 0; transform: translate(-50%, -48%) scale(.96); }
`;

export const Root = Dialog.Root;
export const Trigger = Dialog.Trigger;
export const Portal = Dialog.Portal;

export const Overlay = styled(Dialog.Overlay)`
  position: fixed;
  inset: 0;
  z-index: 800;

  background-color: #00000080;

  animation: ${overlayShow} 300ms cubic-bezier(0.16, 1, 0.3, 1);

  &[data-state="closed"] {
    animation: ${overlayHide} 400ms cubic-bezier(0.3, 1, 0.16, 1);
  }
`;

export const Content = styled(Dialog.Content)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 900;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  
  max-width: 40rem;
  width: 90vw;
  border-radius: 10px;
  padding: 2rem;
  
  background-color: #ffffff;
  
  animation: ${contentShow} 300ms cubic-bezier(0.16, 1, 0.3, 1);

  &[data-state="closed"] {
    animation: ${contentHide} 400ms cubic-bezier(0.3, 1, 0.16, 1);
  }

  &:focus {
    outline: none;
  }
`;

export const Title = styled(Dialog.Title)`
  text-align: center;
  color: #0c456a;
  font-size: 2rem;

  margin: 0;
`;

export const Description = styled(Dialog.Description)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;

  margin: 0;

  text-align: center;
  font-size: 1rem;

  span {
    opacity: 0.8;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export const Button = styled(Dialog.Close)`
  width: 100%;
  border: none;
  padding: 0.75rem 0;
  border-radius: 5px;
  max-width: 20rem;

  background-color: ${({ variant }) =>
    variant === "secondary" ? "#004169" : "#0083ca"};
  color: #ffffff;

  font-size: 1rem;

  cursor: pointer;

  &:hover {
    filter: brightness(0.9);
  }
`;
